import React, {useEffect} from "react";
import config from "appConfig";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { Form, Input, Button, Row, Col, Select, DatePicker } from "antd";

import styles from "./cartSearchForm.scss";
import { PaymentMethod, PaymentMethodText, ShoppingCartStatus, ShoppingCartStatusText } from "../../../models";
import { checkEmptyArray } from "../../../services";
import {
  selectModules,
  selectCategories,
} from "../../../containers/App/selectors";
import { getCredits, selectCredits } from "../../../routes/Credit/credit.ducks";

const CartSearchForm = ({ onSubmit, form }) => {
  const modules = useSelector(selectModules);
  const creditPackages = useSelector(selectCredits);
  const dispatch = useDispatch();

    useEffect(() => {
      dispatch(getCredits());
    }, []);
  
  // Send date-only strings to BE so day boundaries stay in local time.
  // Previously the raw moment was serialized as a full UTC ISO string, which
  // shifted the range by the TZ offset and pulled in transactions from the
  // next day.
  const formatDateOnly = (value: any) =>
    value && moment.isMoment(value) ? value.format("YYYY-MM-DD") : value;

  const handleSubmit = e => {
    e.preventDefault();
    const values = form.getFieldsValue();

    // Filter out empty arrays from the form values
    // when all options are removed from a multiple select, the form value becomes an empty array [] rather than null
    const filteredValues = Object.entries(values).reduce((acc, [key, value]) => {
      if (Array.isArray(value) && value.length === 0) {
        return acc;
      }
      acc[key] = value;
      return acc;
    }, {});

    onSubmit({
      ...filteredValues,
      paymentDateFrom: formatDateOnly(filteredValues.paymentDateFrom),
      paymentDateTo: formatDateOnly(filteredValues.paymentDateTo),
    });
  };

  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };


  return (
    <Row gutter={2} className={styles.form}>
      <Form
        layout="horizontal"
        onSubmit={handleSubmit}
      >
        
        <Col md={12} sm={24} lg={4} xl={4}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("referenceNumber")(
              <Input placeholder={"Poziv na broj"} />
            )}
          </Form.Item>
        </Col>

        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("email")(
              <Input placeholder={"Email"} />
            )}
          </Form.Item>
        </Col>

        <Col md={12} sm={24} lg={4} xl={4}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("paymentMethod")(
              <Select placeholder={"Opcija plaćanja"}>
                <Select.Option key="" value={null}>
                  {"Opcija plaćanja"}
                </Select.Option>
                {PaymentMethodText.map(p => (
                  p.value !== PaymentMethod.storeCredit ? (
                    <Select.Option key={p.value} value={p.value}>
                      {p.name}
                    </Select.Option>
                  ) : null
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("status")(
              <Select placeholder={"Status"}>
                <Select.Option key="" value={null}>
                  {"Status"}
                </Select.Option>
                {ShoppingCartStatusText.map(p => (
                  p.value !== ShoppingCartStatus.awaitingCreditCardPayment ? (
                    <Select.Option key={p.value} value={p.value}>
                      {p.name}
                    </Select.Option>
                  ) : null
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("paymentDateFrom")(
              <DatePicker 
              placeholder={"Datum od"} 
              format={config.dateFormat}
              />
            )}
          </Form.Item>
        </Col>

        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("paymentDateTo")(
              <DatePicker 
                placeholder={"Datum do"} 
                format={config.dateFormat}
              />
            )}
          </Form.Item>
        </Col>

        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("modules")(
              <Select className={styles.multipleSelect}
                placeholder={"Moduli"}
                mode="multiple">
              {modules.map(module => (
                <Select.Option key={module.name} value={module.displayName}>
                  {module.displayName}
                </Select.Option>
              ))}
           </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("storeCredits")(
              <Select className={styles.multipleSelect}
                placeholder={"Paketi kredita"}
                mode="multiple">
                {checkEmptyArray(creditPackages) ? creditPackages.map(creditPackage => (
                    <Select.Option key={creditPackage.id} value={creditPackage.name}>
                      {creditPackage.name}
                    </Select.Option>
                  )) : null
                }
           </Select>
            )}
          </Form.Item>
        </Col>
        
        <Col md={12} sm={24} lg={2} xl={2}>
          <Form.Item className={styles.gutterBox}>
            <Button type="primary" htmlType="submit" className={styles.cartSearchFormActionButton}>
              {"Traži"}
            </Button>
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={2} xl={2}>
          <Form.Item className={styles.gutterBox}>
            <Button onClick={handleReset} className={styles.cartSearchFormActionButton}>
              {"Resetiraj"}
            </Button>
          </Form.Item>
        </Col>
     
      </Form>
    </Row >
  );
};

CartSearchForm.defaultProps = {
  className: "",
  creditPackages: [],
};

export default Form.create()(CartSearchForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/CartSearchForm/CartSearchForm.tsx